export const RoutesApp: Routes = {
    Dashboard: '/app/dashboard',
    Faq: '/app/faq',
    Draft: {
        List: '/app/drafts',
        Details: (id: number | string) => `/app/draft/${id}`,
    },
    Shipment: {
        Drayage: {
            Create: '/app/shipment/drayage/create',
            List: '/app/shipment/drayage/list',
            Details: (id: number | string) => `/app/shipment/drayage/newdetails/${id}`,
            My: '/app/shipment/drayage/myDrayages',
            Import: "/app/shipment/drayage/csvHistory"
        }
    },
    Assets: {
        Driver: '/app/assets/driver',
    },
    Invoice: {
        PaymentPlugin: '/app/invoice/payment-plugin'
    },
    Incentives: '/app/incentives',
    Login: '',
    Maintenance: 'maintenance',
    Settings: {
        Main: '/app/settings',
        Locations: '/app/settings/locations',
        User: '/app/settings/users',
        ProfileAndCompany: '/app/settings/profile-and-company',
        Documents: '/app/settings/hub/documents',
        Vehicles: '/app/settings/vehicle-settings',
        Policies: '/app/settings/policies',
        AgreedRates: '/app/settings/agreed-rates',
        Emails: '/app/settings/emails',
    },
    // Administración de la plataforma: solo `superadmin` (ver `SuperadminGuard`).
    Admin: {
        Main: '/app/admin',
        Insurers: '/app/admin/insurers',
    },
}

interface Routes {
    Dashboard: string
    Faq: string
    Draft: {
        List: string
        Details: (id: number | string) => string
    }
    Invoice: {
        PaymentPlugin: string
    }
    Incentives: string
    Settings: {
        Main: string
        User: string
        Locations: string
        ProfileAndCompany: string
        Documents: string
        Vehicles: string
        Policies: string
        AgreedRates: string
        Emails: string
    }
    Admin: {
        Main: string
        Insurers: string
    }
    Shipment: {
        Drayage: {
            Create: string
            List: string
            Details: (id: number | string) => string
            My: string,
            Import: string
        }
        Update?: (id: number) => string
    }
    Assets: {
        Driver: string
    }
    Login: string,
    Maintenance: string
}
